import {
  CHARACTERISTICS_TYPES,
  CURRENCY_TYPES,
  getOptions,
  MARKET_TYPES,
  MODALITY_TYPES,
  SENIORITY_TYPES,
} from '../../../../Types/constants';

export const GetDetailsFields = (clients: Client[], jobDepartments: JobDepartment[]) => {
  const detailFields: Field[] = [
    {
      label: 'Job reference',
      key: 'jobReference',
      edit: true,
      type: 'text',
    },
    {
      label: 'Position name',
      key: 'position',
      edit: true,
      type: 'text',
    },
    {
      label: 'Headcount',
      key: 'headcount',
      edit: true,
      type: 'text',
      textFieldType: 'number',
    },
    {
      label: 'Client name',
      key: 'client',
      edit: true,
      type: 'autocomplete',
      options: clients,
    },
    {
      label: 'Department',
      key: 'jobDepartment',
      edit: true,
      type: 'autocomplete',
      options: jobDepartments
    },
    {
      label: 'Date requested',
      key: 'requestedDateTime',
      edit: true,
      type: 'date',
    },
    {
      label: 'Close date',
      key: 'closeDateTime',
      edit: false,
      type: 'text',
    },
    {
      label: 'Requester',
      key: 'requester',
      edit: true,
      type: 'text',
    },
    {
      label: 'Tech hub',
      key: 'techHub',
      edit: true,
      type: 'text',
    },
    {
      label: 'Seniority',
      key: 'seniority',
      edit: true,
      type: 'select',
      options: getOptions(SENIORITY_TYPES),
    },
    {
      label: 'Experience (in years)',
      key: 'experience',
      edit: true,
      type: 'text',
      textFieldType: 'number',
    },
    {
      label: 'Minimum salary',
      key: 'minimumSalary',
      edit: true,
      type: 'text',
      textFieldType: 'number',
    },
    {
      label: 'Maximum salary',
      key: 'maximumSalary',
      edit: true,
      type: 'text',
      textFieldType: 'number',
    },
    {
      label: 'Currency',
      key: 'currency',
      edit: true,
      type: 'select',
      options: getOptions(CURRENCY_TYPES),
    },
    {
      label: 'Expected start date',
      key: 'expectedStartDateTime',
      edit: true,
      type: 'date',
    },
    {
      label: 'Characteristics',
      key: 'characteristics',
      edit: true,
      type: 'select',
      options: getOptions(CHARACTERISTICS_TYPES),
    },
    {
      label: 'Market',
      key: 'market',
      edit: true,
      type: 'select',
      options: getOptions(MARKET_TYPES),
    },
    {
      label: 'Modality',
      key: 'modality',
      edit: true,
      type: 'select',
      options: getOptions(MODALITY_TYPES),
    },
  ];

  return detailFields;
};


